"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Switch = {
    parts: ['container', 'thumb', 'track'],
    baseStyle: {},
    defaultProps: {},
    sizes: {},
    variants: {
        black: {
            track: {
                _checked: {
                    bgColor: 'black',
                },
            },
        },
    },
};
exports.default = Switch;
